import {IApiResponse, IApiError, IApiErrors} from "@/models/ApiModels";
import {uiBus} from "@/services/services";
import {AxiosError, AxiosResponse} from "axios";
import {i18n} from "@/main";
import {hasPath, isNil, path} from "ramda";
import {DroppoErrors} from "@/constants/errors";

const pathToError = ['response', 'data', 'errors'];

export class ErrorHandling {

  private static shouldShowGenericMessage(status: number): boolean {

    const ACCEPTED_ERRORS = [
      500,
      404,
    ];

    return ACCEPTED_ERRORS.includes(status);
  }


  private static showGenericMessage() {
    // generic message
    uiBus.emit('genericError:show', i18n.t('errors.unknown'));
    return {};
  }


  private static translateField(each: IApiError, translationsPrefix: string) {

    const params = ('' + each.title).split('|');
    const realTitle = params.shift() || '';

    // try possible keys in order of most specific - least specific
    // we could add translationsPrefix + '.' + each.ref + '.' + realTitle and similar general
    //  if we'd ever need customizing errors by given field name
    const keysToTry = [
      translationsPrefix + '.' + realTitle,
      'errors.general.' + realTitle,
      'errors.unknown',
    ];

    let formatted = '';

    for (const i in keysToTry) {
      if (!keysToTry[i]) { continue; }
      formatted = '' + i18n.t(keysToTry[i], params);
      if (formatted !== keysToTry[i]) {
        break;
      }
    }

    return formatted;

  }

  private static processFormErrors(apiResponse: AxiosResponse<any>,
                                   errors: any,
                                   translationsPrefix: string,
                                   emitGeneral: boolean) {
    // return status code raw and translated on _status and __status fields
    const ret: IApiErrors = {
      __status: "" + apiResponse.status,
    };
    ret._status = '' + ErrorHandling.translateField(
      {ref: '', title: '' + apiResponse.status},
      translationsPrefix,
    );

    errors.forEach((each: IApiError) => {
      const translated = ErrorHandling.translateField(each, translationsPrefix);

      // return general errors translated and untranslated on _ and __ fields
      if (!each.ref) {
        if (emitGeneral) {
          uiBus.emit('genericError:show', translated);
        }
        ret.__ = each.title;
        ret._ = translated;
      } else {
        ret[each.ref] = translated;
      }

    });

    return ret;
  }


  public handleErrorsResponse(err: AxiosError, translationsPrefix: string, emitGeneral: boolean = true) {
    const apiResponse: AxiosResponse<any>|undefined = path(['response'], err);
    const errors: any|undefined = path(['response', 'data', 'errors'], err);



    if (
      apiResponse
      && errors
      && !ErrorHandling.shouldShowGenericMessage(apiResponse.status)
    ) {
      return ErrorHandling.processFormErrors(apiResponse, errors, translationsPrefix, emitGeneral);
    }

    ErrorHandling.showGenericMessage();

  }

}


export const isErrorType = (errType: DroppoErrors, err: AxiosError) => {
  const errorList: any[] | undefined = path(pathToError, err);

  if (errorList) {
    return errorList.length > 0
        && errorList[0].title === errType;
  }

  return false;
};
